import {FeatureCollection, MultiPolygon} from 'geojson';
import {Dispute} from '@/domain/entities/Dispute';
import projectRepository from '@/domain/repository/ProjectRepository';

export const getDisputesOverlayByProject = async (projectUuid: string): Promise<FeatureCollection<MultiPolygon, Omit<Dispute, 'geom'>>> => {
  try {
    return projectRepository.getDisputesOverlayByProject(projectUuid);
  } catch (error) {
    console.error('Error fetching disputes layer', error);
    throw error;
  }
};